import { render, staticRenderFns } from "./LvEventCard.vue?vue&type=template&id=3d51a864"
import script from "./LvEventCard.vue?vue&type=script&lang=js"
export * from "./LvEventCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports